import React, {memo} from 'react';
import parse from 'html-react-parser';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import dynamic from 'next/dynamic';
const DisplayImage = dynamic(() => import('@/components/Ui-components/display-image'));

const sxIndustryGridCardItem = {height: '100%'};

const IndustryLeaders = (props: any) => {
    const {heading, subheading, subheading2, data, className, classNm, cardItemSx} = props;
    return (
        <Box>
            <Box className={`spectrum-header-wrapper  solutions  ${className}`}>
                <Typography className="spectrum-heading color-black text-align-left">{parse(heading)}</Typography>
                <Box className="divder-wrapper">
                    <hr className="divider-line divider-line-left" />
                </Box>
                {subheading && (
                    <Typography className="spectrum-sub-heading color-black spacing text-align-left">{parse(subheading)}</Typography>
                )}
                {subheading2 && (
                    <Typography className="spectrum-sub-heading color-black spacing text-align-left">{parse(subheading2)}</Typography>
                )}
                <Grid
                    container
                    className={`our-reowned-icon-wrapper defi-reowned-icon-wrapper top-spacing crypto-strategic-wrapper industry-leader-card-wrapper ${classNm}`}
                >
                    {data?.map((data: any, index: number) => (
                        <Grid item key={index + 1} md={2.25} sm={4} xs={6} className="strategic-grid-wrapper ">
                            <Box className="strategic-content-wrapper" sx={[sxIndustryGridCardItem, cardItemSx]}>
                                <DisplayImage
                                    src={data.src}
                                    alt={data.heading}
                                    className="helper-card-icon"
                                    width={100}
                                    height={100}
                                    priority={false}
                                />
                                <Typography variant="body2" component="p" className="our-reowned-remote-heading">
                                    {parse(data.heading)}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
};

export default memo(IndustryLeaders);
